import { Proposition } from '../../shared/types';

import { MultiEditCallbacks } from './types';

export class MultiEditRegister {
  private static instance: MultiEditRegister;
  private registry = new Map<string, MultiEditCallbacks>();

  public register(proposition: Proposition, multiEditCallbacks: MultiEditCallbacks): void {
    if (this.registry.has(proposition)) {
      throw new Error(`${proposition} proposition already registered`);
    }

    this.registry.set(proposition, multiEditCallbacks);
  }

  public get(proposition: Proposition): MultiEditCallbacks | null {
    const callbacks = this.registry.get(proposition) as MultiEditCallbacks;

    if (!callbacks) {
      return null;
    }

    return callbacks;
  }

  public static getInstance(): MultiEditRegister {
    if (!MultiEditRegister.instance) {
      MultiEditRegister.instance = new MultiEditRegister();
    }
    return MultiEditRegister.instance;
  }
}
